const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class ComplementaryCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2.2,
          spacing: 8,
        },
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('complementary-carousel')) {
  customElements.define('complementary-carousel', ComplementaryCarousel)
}
